import blackList from './blackList'

const zhCN = { blackList: blackList.zhCN }
const enUS = { blackList: blackList.enUS }
export default { zhCN, enUS }